import { StatusBadge } from 'components/common-form/sidePanel/priceEnhancer/priceImprovement/StatusBadge';
import { BlotterPanelBodyLayout } from 'components/shared/Blotter/BlotterPanel/BlotterPanelBody/BlotterPanelBodyLayout';
import { BlotterPanelHeaderLayout } from 'components/shared/Blotter/BlotterPanel/BlotterPanelHeader/BlotterPanelHeaderLayout';
import { BlotterPanelHeaderTitleLayout } from 'components/shared/Blotter/BlotterPanel/BlotterPanelHeaderTitleLayout';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import * as BlotterPanel from './BlotterPanel';
import type { PriceImprovementBlotterPanelProps } from './PriceImprovementBlotterPanel.connect';
import { connectPriceImprovementBlotterPanel } from './PriceImprovementBlotterPanel.connect';
import { PriceImprovementResponse } from './priceImprovementResponse/priceImprovementResponse';
import { PriceImprovementSummary } from './priceImprovementSummary/priceImprovementSummary';

export const PanelRaw: FC<PriceImprovementBlotterPanelProps> = ({ id, quoteId, status, onClosed }) => {
  const { formatMessage } = useIntl();
  return (
    <BlotterPanel.Panel>
      <BlotterPanelHeaderLayout onClosed={onClosed}>
        <BlotterPanelHeaderTitleLayout>{formatMessage({ id: 'blotterPanel.title' })}</BlotterPanelHeaderTitleLayout>
        <div className="d-flex flex-grow-1 justify-content-end align-items-center">
          <div>
            <StatusBadge status={status} />
          </div>
        </div>
      </BlotterPanelHeaderLayout>
      <BlotterPanelBodyLayout>
        <PriceImprovementSummary id={id} quoteId={quoteId} />
      </BlotterPanelBodyLayout>
      <BlotterPanel.Footer>
        <PriceImprovementResponse id={id} quoteId={quoteId} />
      </BlotterPanel.Footer>
    </BlotterPanel.Panel>
  );
};

export const Panel = connectPriceImprovementBlotterPanel(PanelRaw);
